import { render } from "./ComingSoonDialog.vue?vue&type=template&id=74d6a0a7"
import script from "./ComingSoonDialog.vue?vue&type=script&lang=js"
export * from "./ComingSoonDialog.vue?vue&type=script&lang=js"

import "./ComingSoonDialog.vue?vue&type=style&index=0&id=74d6a0a7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__